import React from 'react';
import classNames from 'classnames';
import styles from './profile-card.module.less';
export var Item = function (_a) {
    var _b;
    var label = _a.label, value = _a.value, className = _a.className;
    return (React.createElement("li", { className: classNames(styles.item, className, (_b = {},
            _b[styles['item-en']] = (i18n === null || i18n === void 0 ? void 0 : i18n.currentLocale) === 'en-US',
            _b)) },
        React.createElement("span", { className: styles.label }, label),
        React.createElement("span", { className: styles.value }, value)));
};
